// extracted by mini-css-extract-plugin
export default {"breakpointxs":"0","validation-error":"ValidationError_validation-error__KNQ15"};